class cOptionsIPRangeAccess {
    constructor() {
        var self = this;
        $(function () { self.onload(); });
    }
    onload() {
        var self = this;
        var elBtnAdd = $('#addiprange');
        var elIPRangeTable = $('#iprange-table');
        var elAllowIPRangeAccessBtn = $('#allow-ip-range-access-btn');
        var elDisallowIPRangeAccessBtn = $('#disallow-ip-range-access-btn');
        var elAddIPRangeSubmitBtn = $('#add-ip-range-submit-btn');
        var elEditIpRangeSubmitBtn = $('#edit-ip-range-submit-btn');
        this.elIPRangeAddForm = $('#add-ip-range-form');
        this.elIPRangeEditForm = $('#edit-ip-range-form');
        this.elInstIdSelectAdd = $('#institution-ip-add');
        this.elInstIdSelectEdit = $('#institution-ip-edit');
        elBtnAdd.click(function () { self.onAddIPRangesClick(); });
        elIPRangeTable.click(function (e) { self.iprangeTableClickHandler(e); });
        $(elAllowIPRangeAccessBtn).click(function (e) { return self.changeIPRangeAccess(this, 1, e); });
        $(elDisallowIPRangeAccessBtn).click(function (e) { return self.changeIPRangeAccess(this, 0, e); });
        $(elAddIPRangeSubmitBtn).click(function (e) { return self.submitAddIPRange(this, e); });
        $(elEditIpRangeSubmitBtn).click(function (e) { return self.submitEditIPRange(this, e); });
        $(elIPRangeTable).dataTable({
            'paging': true,
            'ordering': true,
            'pageLength': 100,
            'lengthMenu': [50, 100, 200, 500],
            'info': true,
            'order': [[1, 'asc']],
            'columnDefs': [
                { "orderable": false, "targets": 0 }
            ],
            //Text translation options
            //Note the required keywords between underscores (e.g _MENU_)
            oLanguage: {
                sSearch: 'Search all columns:',
                sLengthMenu: '_MENU_ IP Ranges per page',
                info: 'Showing page _PAGE_ of _PAGES_',
                zeroRecords: 'Nothing found - sorry',
                infoEmpty: 'No records available',
                infoFiltered: '(filtered from _MAX_ total records)'
            }
        });
    }
    changeIPRangeAccess(btn, state, e) {
        $(btn).button('loading');
        $.ajax({
            url: URL_ADMIN + '/accesscontrol/ipranges/updateiprangeaccess/',
            type: 'post',
            dataType: 'json',
            data: {
                siteiprangeaccess: state,
            },
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                    setTimeout(function () {
                        window.location.reload();
                    }, 2000);
                }
                else {
                    notify.error(response.errors[0]);
                    $(btn).button('reset');
                }
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            },
        });
        return;
    }
    submitAddIPRange(btn, e) {
        if (!$(this.elInstIdSelectAdd).val()) {
            return notify.error("Please select an institution");
        }
        if (!$(this.elIPRangeAddForm).find('*[name="rangestart1"]').val()) {
            return notify.error("Please specify range start 1");
        }
        else if (!$(this.elIPRangeAddForm).find('*[name="rangestart2"]').val()) {
            return notify.error("Please specify range start 2");
        }
        else if (!$(this.elIPRangeAddForm).find('*[name="rangestart3"]').val()) {
            return notify.error("Please specify range start 3");
        }
        else if (!$(this.elIPRangeAddForm).find('*[name="rangestart4"]').val()) {
            return notify.error("Please specify range start 4");
        }
        if (!$(this.elIPRangeAddForm).find('*[name="rangeend1"]').val()) {
            return notify.error("Please specify range end 1");
        }
        else if (!$(this.elIPRangeAddForm).find('*[name="rangeend2"]').val()) {
            return notify.error("Please specify range end 2");
        }
        else if (!$(this.elIPRangeAddForm).find('*[name="rangeend3"]').val()) {
            return notify.error("Please specify range end 3");
        }
        else if (!$(this.elIPRangeAddForm).find('*[name="rangeend4"]').val()) {
            return notify.error("Please specify range end 4");
        }
        $(btn).button('loading');
        $(this.elIPRangeAddForm).ajaxSubmit({
            url: URL_ADMIN + '/accesscontrol/ipranges/addiprange/',
            type: 'post',
            dataType: 'json',
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                    setTimeout(function () {
                        window.location.reload();
                    }, 2000);
                }
                else {
                    notify.error(response.errors[0]);
                    $(btn).button('reset');
                }
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            },
        });
        return;
    }
    submitEditIPRange(btn, e) {
        if (!$(this.elInstIdSelectEdit).val()) {
            return notify.error("Please select an institution");
        }
        if (!$(this.elIPRangeEditForm).find('*[name="rangestart1"]').val()) {
            return notify.error("Please specify range start 1");
        }
        else if (!$(this.elIPRangeEditForm).find('*[name="rangestart2"]').val()) {
            return notify.error("Please specify range start 2");
        }
        else if (!$(this.elIPRangeEditForm).find('*[name="rangestart3"]').val()) {
            return notify.error("Please specify range start 3");
        }
        else if (!$(this.elIPRangeEditForm).find('*[name="rangestart4"]').val()) {
            return notify.error("Please specify range start 4");
        }
        if (!$(this.elIPRangeEditForm).find('*[name="rangeend1"]').val()) {
            return notify.error("Please specify range end 1");
        }
        else if (!$(this.elIPRangeEditForm).find('*[name="rangeend2"]').val()) {
            return notify.error("Please specify range end 2");
        }
        else if (!$(this.elIPRangeEditForm).find('*[name="rangeend3"]').val()) {
            return notify.error("Please specify range end 3");
        }
        else if (!$(this.elIPRangeEditForm).find('*[name="rangeend4"]').val()) {
            return notify.error("Please specify range end 4");
        }
        $(btn).button('loading');
        $(this.elIPRangeEditForm).ajaxSubmit({
            url: URL_ADMIN + '/accesscontrol/ipranges/updateiprange/',
            type: 'post',
            dataType: 'json',
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                    setTimeout(function () {
                        window.location.reload();
                    }, 2000);
                }
                else {
                    notify.error(response.errors[0]);
                    $(btn).button('reset');
                }
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            },
        });
        return;
    }
    iprangeTableClickHandler(e) {
        var target = e.target;
        var row = $(target).closest('tr').get(0);
        if ($(target).hasClass('edit')) {
            this.onIPRangeEditClick(row);
        } else if (($(target).hasClass('disable'))) {
            this.onIPRangeDeactivateClick(row);
        }
        else if (($(target).hasClass('enable'))) {
            this.onIPRangeEnableClick(row);
        }
        else if ($(target).hasClass('del')) {
            this.onIPRangeDelClick(row);
        }
    }
    onIPRangeEditClick(row) {
        var ip_range_start = $(row).data('ip-range-start').split(/\./);
        var ip_range_end = $(row).data('ip-range-end').split(/\./);
        var institutionId = $(row).data('institution-id');
        var isDisabled = $(row).data('is-disabled') == "1" ? true : false;
        $('#institution-ip-edit').val(institutionId);
        $('#edit-ip-range-modal #edit-rangestart1').val(ip_range_start[0]);
        $('#edit-ip-range-modal #edit-rangestart2').val(ip_range_start[1]);
        $('#edit-ip-range-modal #edit-rangestart3').val(ip_range_start[2]);
        $('#edit-ip-range-modal #edit-rangestart4').val(ip_range_start[3]);
        $("#edit-ip-range-modal #edit-rangeend1").val(ip_range_end[0]);
        $("#edit-ip-range-modal #edit-rangeend2").val(ip_range_end[1]);
        $("#edit-ip-range-modal #edit-rangeend3").val(ip_range_end[2]);
        $("#edit-ip-range-modal #edit-rangeend4").val(ip_range_end[3]);
        $("#edit-ip-range-modal #edit-rangeend4").val(ip_range_end[3]);
        $("#edit-ip-range-modal #edit-is-disabled").prop('checked', isDisabled);
        $("#edit-ip-range-modal #edit-id").val($(row).data('id'));
        $('#edit-ip-range-modal').modal('show');
    }
    getIpRangeById(ipRangeId) {
        for (var i in g_options_ipranges) {
            if (g_options_ipranges[i].id == ipRangeId) {
                return g_options_ipranges[i];
            }
        }
        return null;
    }
    onIPRangeDelClick(row) {
        var iprangeId = row.getAttribute('rel');
        if (confirm('Are you sure you want to delete this IP range?')) {
            this.deleteIPRange(iprangeId);
        }
    }
    onIPRangeDeactivateClick(row) {
        var iprangeId = row.getAttribute('rel');
        if (confirm('Are you sure you want to deactivate this IP range?')) {
            this.deactivateIPRange(iprangeId);
        }
    }
    onIPRangeEnableClick(row) {
        var iprangeId = row.getAttribute('rel');
        if (confirm('Are you sure you want to enable this IP range?')) {
            this.enableIPRange(iprangeId);
        }
    }
    onAddIPRangesClick() {
        this.clearIPRangeAddPopUp();
        this.elIPRangeAddPopup.dialog('open');
    }
    deleteIPRange(ip_range_id) {
        $.ajax({
            url: URL_ADMIN + '/accesscontrol/ipranges/deleteiprange/',
            type: 'post',
            dataType: 'json',
            data: {
                ip_range_id: ip_range_id
            },
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                    setTimeout(function () {
                        window.location.reload();
                    }, 2000);
                }
                else {
                    notify.error(response.errors[0]);
                }
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR);
            },
        });
        return false;
    }
    deactivateIPRange(ip_range_id) {
        $.ajax({
            url: URL_ADMIN + '/accesscontrol/ipranges/deactivateiprange/',
            type: 'post',
            dataType: 'json',
            data: {
                ip_range_id: ip_range_id
            },
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                    setTimeout(function () {
                        window.location.reload();
                    }, 2000);
                }
                else {
                    notify.error(response.errors[0]);
                }
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR);
            },
        });
        return false;
    }
    enableIPRange(ip_range_id) {
        $.ajax({
            url: URL_ADMIN + '/accesscontrol/ipranges/enableiprange/',
            type: 'post',
            dataType: 'json',
            data: {
                ip_range_id: ip_range_id
            },
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                    setTimeout(function () {
                        window.location.reload();
                    }, 2000);
                }
                else {
                    notify.error(response.errors[0]);
                }
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR);
            },
        });
        return false;
    }
}
